import React, { useState, useEffect } from "react";
import { MsalAuthenticationTemplate, useMsal } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { loginRequest } from "../authConfig";
import { Loading } from "../components/Loading";
import { ErrorComponent } from "../components/ErrorComponent";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import { useSearchParams } from "react-router-dom";
import { api_path } from "../shared";
import { useNavigate } from "react-router-dom";

export function Home() {
  const authRequest = {
    ...loginRequest,
  };
  const getUserID = JSON.parse(localStorage.getItem("USER_ID"));
  const getUserRole = JSON.parse(localStorage.getItem("USER_ROLE_ID"));
  const getUserEMail = JSON.parse(localStorage.getItem("USER_EMAIL"));
  const getEmpCode = JSON.parse(localStorage.getItem("USER_EMPCODE"));
  const [searchParams] = useSearchParams();
  const status = searchParams.get("status");
  const { instance, accounts } = useMsal();
  const [accessToken, setAccessToken] = useState(null);
  const name = accounts[0] && accounts[0].name;
  const [showMsg, setMsg] = useState("");
  const [showMenu, setShowMenu] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    if (localStorage.getItem("USER_ROLE_ID") !== "undefined") {
      const getUserRole = JSON.parse(localStorage.getItem("USER_ROLE_ID"));
      console.log("Current user role..." + getUserRole);
      if (status == "inactive") {
        setMsg("Your active was disabled.");
        setShowMenu(false);
      } else if (status == "norole") {
        setMsg("Please wait administrator to assign role.");
        setShowMenu(false);
      } else if (status == "haverole") {
        setMsg("Welcome " + name);
        setShowMenu(true);
      } else if (status == "denined") {
        setMsg("Sorry, you do not have access to this page.");
        setShowMenu(false);
      } else {
        setMsg("Welcome " + name);
        setShowMenu(true);
      }

      setShowMenu(true);
      // console.log("user id..." +getUserID)
      //  if (getUserID == 73 || getUserID == 59 || getUserRole == 1 || getUserRole == 3 || getUserRole == 7 || getUserRole == 9 || getUserRole == 14) {
      //   navigate("/s-crm/dashboard"); // ✅ เปลี่ยนหน้าแบบไม่ reload
      // }
      if (canAccessDashboard(getUserID, getUserRole)) {
        navigate("/s-crm/dashboard");
      }
    } else {
      //no user profile
      setShowMenu(false);
      window.location = "./login";
    }
  }, []);
  function canAccessDashboard(userID, userRole) {
    const allowedIDs = [73, 59];
    const allowedRoles = [1, 3, 7, 9, 14];
    return (
      allowedIDs.includes(Number(userID)) ||
      allowedRoles.includes(Number(userRole))
    );
  }

  function RequestAccessToken() {
    const request = {
      ...loginRequest,
      account: accounts[0],
    };
    // Silently acquires an access token which is then attached to a request for Microsoft Graph data
    instance
      .acquireTokenSilent(request)
      .then((response) => {
        setAccessToken(response.accessToken);
      })
      .catch((e) => {
        instance.acquireTokenPopup(request).then((response) => {
          setAccessToken(response.accessToken);
        });
      });
  }
  const [MenuList, setMenuList] = useState([]);

  useEffect(() => {
    if (localStorage.getItem("USER_ROLE_ID") !== "undefined") {
      var data = {
        ROLE_ID: getUserRole,
        USER_EMAIL: getUserEMail,
        MENU_URL: "/",
      };
      fetch(api_path + "/MS_MENU.php", {
        method: "POST",
        headers: {
          Accept: "application/form-data",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((res) => {
          setMenuList(res);
        });
    } else {
      setMenuList([]);
      //window.location = "./login";
    }
    // });
  }, []);
  return (
    <>
      <MsalAuthenticationTemplate
        interactionType={InteractionType.Redirect}
        authenticationRequest={authRequest}
        errorComponent={ErrorComponent}
        loadingComponent={Loading}
      >
        <Container maxWidth="xl">
          <Grid container spacing={2}>
            <br />
            <br />
          </Grid>
          <Grid container alignContent={"center"}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <div className="h2">{showMsg}</div>
                <br />
              </Grid>
            </Grid>

            {!showMenu && (
              <a
                href="https://apps.sinologistics.co.th/s-crm/Logout"
                className="cardBox"
              >
                Logout
              </a>
            )}
            {showMenu && (
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      {MenuList.length > 0 && (
                        <Grid item xs={12}>
                          {MenuList.map((menu) => (
                            <Grid item xs={4} sm={4} className="cardBox">
                              <a href={menu.MENU_URL} target="_blank">
                                {(() => {
                                  switch (menu.MENU_ID) {
                                    case "17":
                                      return <div>👨🏻‍💻</div>;
                                    case "23":
                                      return <div>📝</div>;
                                    case "10":
                                      return <div>💲</div>;
                                    case "11":
                                      return <div>🧾</div>;
                                    case "21":
                                      return <div>☎️</div>;
                                    case "22":
                                      return <div>🛒</div>;
                                    case "32":
                                      return <div>🧾</div>;
                                    case "15":
                                      return <div>🙎🏼‍♂️</div>;
                                    case "16":
                                      return <div>➡️</div>;
                                    case "47":
                                      return <div>🗽</div>;
                                    case "48":
                                      return <div>📂</div>;
                                    case "49":
                                      return <div>✈️</div>;
                                    default:
                                      return <div>📝</div>;
                                  }
                                })()}

                                {menu.MENU_TEXT}
                              </a>
                            </Grid>
                          ))}
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Container>
      </MsalAuthenticationTemplate>
    </>
  );
}
